import Headroom from 'headroom.js';

const psiHeader = document.querySelector('.psi-header');
const scrollThreashold = 110;
let isNavbarScrolled = false;

initPsiHeader(psiHeader, scrollThreashold);
window.addEventListener('DOMContentLoaded', changeBgNavbar, { passive: true })
window.addEventListener('resize', changeBgNavbar, { passive: true });
window.addEventListener('scroll', changeBgNavbar, { passive: true });

function initPsiHeader() {
  if (!psiHeader) return;

  const settings = {
    offset: scrollThreashold
  };

  const __headroomInstance = new Headroom(psiHeader, settings);
  __headroomInstance.init();
}

function changeBgNavbar() {
  if (!psiHeader) return;

  const getDataValue = psiHeader.getAttribute('data-change');
  const shouldChangeBgNavbar = (getDataValue === 'true');
  if (!shouldChangeBgNavbar) return;

  const scrollY = window.scrollY;
  if (scrollY > scrollThreashold && !isNavbarScrolled) {
    psiHeader.classList.add('navbar-scrolled');
    isNavbarScrolled = true;
  } else if (scrollY <= scrollThreashold && isNavbarScrolled) {
    psiHeader.classList.remove('navbar-scrolled');
    isNavbarScrolled = false;
  }
}
